import React, { FC, useEffect } from 'react';
import { LandscapeProjectsAddProjectsGeneralInformationLeadPartnersTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useParams } from 'react-router-dom';
import Spinner from '../../atoms/Spinner/Spinner';
import {
  deleteProjectSupporters,
  fetchProjectSupportersByIds,
  fetchProjectSupportersByOrganizationId,
} from '../../../store/tradeAPI/projectSupporter/reducers/project-supporters.slice';
import { ProjectOrganizationResponseDto } from '../../../store/tradeAPI/projectSupporter/dto/response/project-organization-response.dto';
import { ProjectOrganizationRelationType } from '../../../store/tradeAPI/projectSupporter/project-organization-relation-type';
import LandscapeProjectNotSavedInfoPage from '../LandscapeProjectNotSavedInfoPage';

interface LandscapeProjectsAddProjectsGeneralInformationLeadPartnersPageProps {}

const LandscapeProjectsAddProjectsGeneralInformationLeadPartnersPage: FC<
  LandscapeProjectsAddProjectsGeneralInformationLeadPartnersPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { projectId } = useParams();

  const { projectBuyers, status } = useSelector(
    (state: RootState) => state.projectSupporterSlice
  );

  useEffect(() => {
    if (projectId && projectId !== 'new-project') {
      dispatch(
        fetchProjectSupportersByIds({
          id: projectId,
          relationShipType: ProjectOrganizationRelationType.Initiator,
        })
      );
    }
  }, [dispatch, projectId]);

  const handleDelete = async (buyerId: string) => {
    await dispatch(fetchProjectSupportersByOrganizationId(buyerId))
      .unwrap()
      .then((supporters: ProjectOrganizationResponseDto[]) => {
        const supporterToDelete = supporters.find(
          (supporter) => supporter.projectId === projectId
        )!;

        dispatch(deleteProjectSupporters(supporterToDelete.id))
          .unwrap()
          .then(() => {
            dispatch(
              fetchProjectSupportersByIds({
                id: projectId!,
                relationShipType: ProjectOrganizationRelationType.Initiator,
              })
            ).unwrap();
          });
      });
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return projectId && projectId !== 'new-project' ? (
    <LandscapeProjectsAddProjectsGeneralInformationLeadPartnersTemplate
      data={projectBuyers ?? []}
      handleDelete={handleDelete}
    />
  ) : (
    <LandscapeProjectNotSavedInfoPage />
  );
};

export default LandscapeProjectsAddProjectsGeneralInformationLeadPartnersPage;
